/* eslint no-use-before-define: ["error", { "functions": false }] */
/* eslint camelcase: ["error", {allow: ["short_name", "trip_short_name"]}] */

import {TRAVEL_MODES} from './constants'

function stepTitle(step) {
  switch (step.travel_mode) {
    case TRAVEL_MODES.TRANSIT:
      return stepTitleTransit(step)
    case TRAVEL_MODES.WALKING:
      return stepTitleWalking(step)
    default:
      return step.name
  }
}

function stepTitleTransit(step) {
  const {trip_short_name, line: {short_name, name, vehicle: {type}}} = step.transit

  const vehicleType = toPascalCase(type)

  const values = {
    name: trip_short_name || short_name || name
  }

  /**
   * Available vehicle types
   * https://developers.google.com/maps/documentation/javascript/directions#VehicleType
   */
  if (Vue.i18n.te(`planner.stepTitle${vehicleType}`)) {
    return Vue.i18n.t(`planner.stepTitle${vehicleType}`, values)
  }

  return Vue.i18n.t('planner.stepTitle', values)
}

function stepTitleWalking(step) {
  return Vue.i18n.t('planner.walkTitle', {distance: step.distance.text})
}

function toPascalCase(str) {
  return _.upperFirst(_.lowerCase(str))
}

export default stepTitle
